module.exports = __webpack_public_path__ + "static/img/ct2.9653e78.jpg";